import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { PostHogProvider } from 'posthog-js/react';
const options = {
  api_host: 'https://us.i.posthog.com'
};
render(<PostHogProvider apiKey="phc_FPEBbcpzvxalOOLj7OHj1wCwItKUb95YaCxP8dOaPpD" options={options} data-id="element-239">
    <App data-id="element-240" />
  </PostHogProvider>, document.getElementById('root'));